import {
  FETCH_SETTLEMENTS_REQUEST,
  FETCH_SETTLEMENTS_SUCCESS,
  FETCH_SETTLEMENTS_FAILURE,
  PROCESS_PAYOUT_SUCCESS
} from "../actions/SettlementActions";

const initialState = {
  settlements: [],
  count: 0,
  loading: false,
  error: null
};

const SettlementReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SETTLEMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case FETCH_SETTLEMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        settlements: action.payload.settlements,
        count: action.payload.count,
        error: null
      };
    
    case FETCH_SETTLEMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case PROCESS_PAYOUT_SUCCESS:
      return {
        ...state,
        settlements: state.settlements.map(settlement =>
          settlement.id === action.payload
            ? { ...settlement, status: 'completed', payoutDate: new Date().toISOString() }
            : settlement
        )
      };
    
    default:
      return state;
  }
};

export default SettlementReducer;